import { type ReactNode } from 'react';
import { UAParser } from 'ua-parser-js';
import { type Config } from '#types.ts';
import { Context } from './Context.ts';

export type Props = {
  children: ReactNode;
  config: Config;
};

export const Provider = ({ children, config }: Props) => {
  return (
    <Context.Provider value={{ config, uaParser: UAParser(globalThis.navigator.userAgent) }}>
      {children}
    </Context.Provider>
  );
};
